import { render, staticRenderFns } from "./Transilvania.vue?vue&type=template&id=0646a6d4&"
import script from "./Transilvania.vue?vue&type=script&lang=js&"
export * from "./Transilvania.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports